angular.module('am4')
.filter('webDisplayName', function($translate) {
    return function(input) {
        try {
            const parts = JSON.parse(input);
            return parts.console && parts.frame ?
                [parts.frame, parts.console].map($translate.instant).join(' ') :
                null;
        } catch (e) {
            console.log(e); // eslint-disable-line no-console
            return input;
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/filters/webDisplayName.js